import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"
import _imports_0 from '@/assets/images/logo_iacd.png'


const _hoisted_1 = { class: "d-flex justify-content-center align-items-center min-vh-100" }
const _hoisted_2 = { class: "container-box" }
const _hoisted_3 = { class: "fo" }
const _hoisted_4 = {
  class: "form-header",
  style: {"padding-top":"0!important","margin-top":"0!important"}
}
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: "logo",
  class: "logo-img"
}
const _hoisted_6 = { class: "fw-bold mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "stepper d-flex justify-content-center align-items-center mb-4"
}
const _hoisted_8 = { class: "form-content" }
const _hoisted_9 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center mb-4 rounded-3",
  role: "alert"
}
const _hoisted_10 = { class: "fw-medium" }
const _hoisted_11 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center mb-4 rounded-3",
  role: "alert"
}
const _hoisted_12 = { class: "fw-medium" }
const _hoisted_13 = { class: "form-box register-box" }
const _hoisted_14 = { class: "row g-3" }
const _hoisted_15 = { class: "col-sm-4" }
const _hoisted_16 = { class: "col-sm-4" }
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = { class: "col-sm-4" }
const _hoisted_19 = { class: "col-sm-4" }
const _hoisted_20 = { class: "col-sm-4" }
const _hoisted_21 = { class: "col-sm-4" }
const _hoisted_22 = { class: "col-sm-4" }
const _hoisted_23 = { class: "col-sm-4" }
const _hoisted_24 = { class: "col-sm-4" }
const _hoisted_25 = { class: "col-md-8" }
const _hoisted_26 = { class: "tel-input-fix" }
const _hoisted_27 = { class: "row g-3" }
const _hoisted_28 = { class: "col-md-7" }
const _hoisted_29 = { class: "row g-3" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "col-md-12" }
const _hoisted_33 = { class: "col-md-12 mt-4" }
const _hoisted_34 = { class: "col-md-5" }
const _hoisted_35 = { class: "dz-message needsclick" }
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = {
  key: 0,
  class: "text-muted text-center mt-2"
}
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "position-relative" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "position-relative" }
const _hoisted_42 = { class: "row g-3" }
const _hoisted_43 = { class: "col-12" }
const _hoisted_44 = { class: "recap-grid mb-3" }
const _hoisted_45 = { class: "recap-item" }
const _hoisted_46 = { class: "recap-item" }
const _hoisted_47 = { class: "recap-item" }
const _hoisted_48 = { class: "recap-item" }
const _hoisted_49 = { class: "recap-item" }
const _hoisted_50 = { class: "recap-item" }
const _hoisted_51 = { class: "recap-item" }
const _hoisted_52 = { class: "recap-item" }
const _hoisted_53 = { class: "recap-item" }
const _hoisted_54 = { class: "recap-item" }
const _hoisted_55 = { class: "recap-item" }
const _hoisted_56 = { class: "recap-item" }
const _hoisted_57 = { class: "recap-item" }
const _hoisted_58 = { class: "recap-item" }
const _hoisted_59 = { class: "recap-item" }
const _hoisted_60 = { class: "d-flex justify-content-between mt-3 mb-10" }
const _hoisted_61 = {
  key: 2,
  type: "submit",
  class: "btn btn-success"
}
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "form-box login-box" }
const _hoisted_65 = { class: "input-box mb-3" }
const _hoisted_66 = { class: "position-relative" }
const _hoisted_67 = { class: "input-box mb-4" }
const _hoisted_68 = { class: "position-relative" }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { class: "panel" }
const _hoisted_73 = {
  class: "fw-bold text-center panel-title",
  style: {"color":"white"}
}
const _hoisted_74 = {
  class: "panel-sub",
  style: {"color":"white"}
}
const _hoisted_75 = {
  key: 0,
  class: "my-ultimate-otp-modal"
}
const _hoisted_76 = { class: "my-ultimate-otp-card" }
const _hoisted_77 = { class: "header" }
const _hoisted_78 = { class: "body" }
const _hoisted_79 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center mb-4 rounded-3",
  role: "alert"
}
const _hoisted_80 = { class: "fw-medium" }
const _hoisted_81 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center mb-4 rounded-3",
  role: "alert"
}
const _hoisted_82 = { class: "fw-medium" }
const _hoisted_83 = { class: "otp-container" }
const _hoisted_84 = ["onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_85 = { class: "footer" }
const _hoisted_86 = ["disabled"]
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = ["disabled"]
const _hoisted_90 = {
  key: 0,
  class: "my-ultimate-otp-modal"
}
const _hoisted_91 = { class: "my-ultimate-otp-card" }
const _hoisted_92 = { class: "header" }
const _hoisted_93 = { class: "body" }
const _hoisted_94 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center mb-4 rounded-3",
  role: "alert"
}
const _hoisted_95 = { class: "fw-medium" }
const _hoisted_96 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center mb-4 rounded-3",
  role: "alert"
}
const _hoisted_97 = { class: "fw-medium" }
const _hoisted_98 = { class: "otp-container" }
const _hoisted_99 = ["onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_100 = { class: "footer" }
const _hoisted_101 = ["disabled"]
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Vue3CountryIntl = _resolveComponent("Vue3CountryIntl")!
  const _component_VueTelInput = _resolveComponent("VueTelInput")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(['forms-column', _ctx.isLoginActive ? 'login-narrow' : 'register-wide'])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.isLoginActive)
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : _createCommentVNode("", true),
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.isLoginActive ? "Connectez-vous" : "Inscrivez-vous"), 1)
            ]),
            (!_ctx.isLoginActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["step", { active: _ctx.currentStep >= 1, completed: _ctx.currentStep > 1 }])
                  }, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("div", { class: "step-circle" }, "1", -1),
                    _createElementVNode("span", { class: "step-label" }, "Informations Générales", -1)
                  ]))], 2),
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "step-line" }, null, -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["step", { active: _ctx.currentStep >= 2, completed: _ctx.currentStep > 2 }])
                  }, [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("div", { class: "step-circle" }, "2", -1),
                    _createElementVNode("span", { class: "step-label" }, "Informations Légales & Sécurité", -1)
                  ]))], 2),
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "step-line" }, null, -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["step", { active: _ctx.currentStep >= 3, completed: _ctx.currentStep > 3 }])
                  }, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("div", { class: "step-circle" }, "3", -1),
                    _createElementVNode("span", { class: "step-label" }, "Récapitulatif & Confirmation", -1)
                  ]))], 2)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.globalSuccess)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _cache[23] || (_cache[23] = _createElementVNode("i", { class: "bi bi-check-circle-fill me-2" }, null, -1)),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.globalSuccess), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.globalError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _cache[24] || (_cache[24] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2" }, null, -1)),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.globalError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, {
                name: "slide-fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (!_ctx.isLoginActive)
                      ? (_openBlock(), _createBlock(_component_Form, {
                          key: 0,
                          ref: "registerForm",
                          onSubmit: _ctx.onSubmitRegister,
                          "validation-schema": _ctx.registerSchema
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _withDirectives(_createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_Field, {
                                    name: "nom",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Nom"
                                  }),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "nom",
                                    class: "text-danger"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createVNode(_component_Field, {
                                    name: "prenom",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Prénom"
                                  }),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "prenom",
                                    class: "text-danger"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_component_Field, {
                                    name: "email",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Email"
                                  }),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "email",
                                    class: "text-danger"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_Field, { name: "statut" }, {
                                    default: _withCtx(({ field }) => [
                                      _createVNode(_component_Multiselect, _mergeProps({
                                        options: _ctx.statutOptions,
                                        modelValue: field.value,
                                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                      }, field, { placeholder: "Statut" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "statut",
                                    class: "text-danger"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_Field, {
                                    name: "nomOrganisation",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Nom de l'organisation"
                                  }),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "nomOrganisation",
                                    class: "text-danger"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_component_Field, {
                                    name: "siteweb",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Site web de l'organisation"
                                  }),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "siteweb",
                                    class: "text-danger"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_Field, {
                                    name: "adresse",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Adresse"
                                  }),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "adresse",
                                    class: "text-danger"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                  _createVNode(_component_Field, {
                                    name: "ville",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Ville"
                                  }),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "ville",
                                    class: "text-danger"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(_component_Field, {
                                    name: "codePostal",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Code postal"
                                  }),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "codePostal",
                                    class: "text-danger"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  _createVNode(_component_Field, { name: "pays" }, {
                                    default: _withCtx(({ errors }) => [
                                      _createVNode(_component_Vue3CountryIntl, {
                                        onChange: _ctx.onCountryChange,
                                        placeholder: "Sélectionnez votre pays",
                                        showCode: false,
                                        class: _normalizeClass(["form-control", { 'border-danger': errors.length }]),
                                        style: {"height":"50px"}
                                      }, null, 8, ["onChange", "class"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "pays",
                                    class: "text-danger mt-1"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                  _createVNode(_component_Field, { name: "telephone" }, {
                                    default: _withCtx(({ field }) => [
                                      _createElementVNode("div", _hoisted_26, [
                                        (_openBlock(), _createBlock(_component_VueTelInput, _mergeProps({
                                          modelValue: field.value,
                                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                        }, field, {
                                          mode: "international",
                                          defaultCountry: _ctx.selectedCountryCode,
                                          key: _ctx.selectedCountryCode,
                                          inputOptions: { placeholder: 'Entrez votre numéro de téléphone' },
                                          onOnInput: _ctx.onTelInput
                                        }), null, 16, ["modelValue", "onUpdate:modelValue", "defaultCountry", "onOnInput"]))
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "telephone",
                                    class: "text-danger mt-1"
                                  })
                                ])
                              ], 512), [
                                [_vShow, _ctx.currentStep === 1]
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, [
                                      _createVNode(_component_Field, {
                                        name: "numfiscal",
                                        type: "text",
                                        class: "form-control",
                                        placeholder: "Numéro fiscal"
                                      }),
                                      _createVNode(_component_ErrorMessage, {
                                        name: "numfiscal",
                                        class: "text-danger"
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                      _createVNode(_component_Field, {
                                        name: "numRccm",
                                        type: "text",
                                        class: "form-control",
                                        placeholder: "Numéro RCCM"
                                      }),
                                      _createVNode(_component_ErrorMessage, {
                                        name: "numRccm",
                                        class: "text-danger"
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                      _createVNode(_component_Field, { name: "typeDocument" }, {
                                        default: _withCtx(({ field }) => [
                                          _createVNode(_component_Multiselect, _mergeProps({
                                            options: _ctx.documentOptions,
                                            modelValue: field.value,
                                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                          }, field, { placeholder: "Selectionnez le Type de document" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ErrorMessage, {
                                        name: "typeDocument",
                                        class: "text-danger"
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_33, [
                                      _createVNode(_component_Field, { name: "message" }, {
                                        default: _withCtx(({ field }) => [
                                          _createElementVNode("textarea", _mergeProps(field, {
                                            class: "form-control",
                                            rows: "2",
                                            placeholder: "Ajoutez un message si vous le souhaitez..."
                                          }), null, 16)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ErrorMessage, {
                                        name: "message",
                                        class: "text-danger"
                                      })
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                  _createVNode(_component_Field, { name: "document" }, {
                                    default: _withCtx(({ field }) => [
                                      _createElementVNode("div", _mergeProps({
                                        id: "myDropzone",
                                        class: ["dropzone custom-dropzone", { 'disabled-dropzone': !_ctx.registerForm?.values?.typeDocument }]
                                      }, field), [
                                        _createElementVNode("div", _hoisted_35, [
                                          _cache[29] || (_cache[29] = _createElementVNode("i", { class: "bi bi-cloud-upload-fill fs-1 text-primary mb-3" }, null, -1)),
                                          _createElementVNode("p", _hoisted_36, [
                                            _cache[25] || (_cache[25] = _createTextVNode("Déposez votre ", -1)),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.selectedDocumentLabel), 1),
                                            _cache[26] || (_cache[26] = _createTextVNode(" ici", -1)),
                                            _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                                            _cache[28] || (_cache[28] = _createElementVNode("small", { class: "text-muted" }, "ou cliquez pour importer", -1))
                                          ])
                                        ])
                                      ], 16)
                                    ]),
                                    _: 1
                                  }),
                                  (!_ctx.registerForm?.values?.typeDocument)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_37, " Veuillez d’abord sélectionner le type de document "))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "document",
                                    class: "text-danger"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _createVNode(_component_Field, {
                                      name: "password",
                                      type: _ctx.showPassword ? 'text' : 'password',
                                      class: "form-control pe-5",
                                      placeholder: "Mot de passe"
                                    }, null, 8, ["type"]),
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["bi password-eye position-absolute", _ctx.showPassword ? 'bi-eye' : 'bi-eye-slash']),
                                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
                                      style: {"top":"50%","right":"10px","transform":"translateY(-50%)","cursor":"pointer"}
                                    }, null, 2)
                                  ]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "password",
                                    class: "text-danger mt-1"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _createVNode(_component_Field, {
                                      name: "confirm_password",
                                      type: _ctx.showPassword ? 'text' : 'password',
                                      class: "form-control",
                                      placeholder: "Confirmer mot de passe"
                                    }, null, 8, ["type"]),
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["bi password-eye position-absolute", _ctx.showPassword ? 'bi-eye' : 'bi-eye-slash']),
                                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
                                      style: {"top":"50%","right":"10px","transform":"translateY(-50%)","cursor":"pointer"}
                                    }, null, 2)
                                  ]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: "confirm_password",
                                    class: "text-danger"
                                  })
                                ])
                              ], 512), [
                                [_vShow, _ctx.currentStep === 2]
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, [
                                  _cache[45] || (_cache[45] = _createElementVNode("h5", { class: "mb-3" }, "Récapitulatif de votre inscription", -1)),
                                  _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("div", _hoisted_45, [
                                      _cache[30] || (_cache[30] = _createElementVNode("strong", null, "Nom :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.nom), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                      _cache[31] || (_cache[31] = _createElementVNode("strong", null, "Prénom :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.prenom), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_47, [
                                      _cache[32] || (_cache[32] = _createElementVNode("strong", null, "Email :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.email), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_48, [
                                      _cache[33] || (_cache[33] = _createElementVNode("strong", null, "Statut :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.statut), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_49, [
                                      _cache[34] || (_cache[34] = _createElementVNode("strong", null, "Nom Organisation :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.nomOrganisation), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                      _cache[35] || (_cache[35] = _createElementVNode("strong", null, "Site web :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.siteweb), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_51, [
                                      _cache[36] || (_cache[36] = _createElementVNode("strong", null, "Adresse :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.adresse), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_52, [
                                      _cache[37] || (_cache[37] = _createElementVNode("strong", null, "Ville :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.ville), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_53, [
                                      _cache[38] || (_cache[38] = _createElementVNode("strong", null, "Code Postal :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.codePostal), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_54, [
                                      _cache[39] || (_cache[39] = _createElementVNode("strong", null, "Pays :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.pays), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_55, [
                                      _cache[40] || (_cache[40] = _createElementVNode("strong", null, "Téléphone :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.telephone), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_56, [
                                      _cache[41] || (_cache[41] = _createElementVNode("strong", null, "Numéro fiscal :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.numfiscal), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_57, [
                                      _cache[42] || (_cache[42] = _createElementVNode("strong", null, "Numéro RCCM :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.numRccm), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_58, [
                                      _cache[43] || (_cache[43] = _createElementVNode("strong", null, "Type de document :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.typeDocument), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_59, [
                                      _cache[44] || (_cache[44] = _createElementVNode("strong", null, "Message :", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.registerForm?.values.message), 1)
                                    ])
                                  ]),
                                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "alert alert-info" }, "Veuillez vérifier vos informations avant de valider votre inscription.", -1))
                                ])
                              ], 512), [
                                [_vShow, _ctx.currentStep === 3]
                              ]),
                              _createElementVNode("div", _hoisted_60, [
                                (_ctx.currentStep > 1)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-secondary",
                                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.prevStep && _ctx.prevStep(...args)))
                                    }, "Précédent"))
                                  : _createCommentVNode("", true),
                                (_ctx.currentStep < _ctx.totalSteps)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "btn btn-primary",
                                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)))
                                    }, "Suivant"))
                                  : (_openBlock(), _createElementBlock("button", _hoisted_61, [
                                      (_ctx.isLoginDisabled)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_62, " Patientez " + _toDisplayString(_ctx.otpCode) + " secondes ", 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_63, " Valider "))
                                    ]))
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["onSubmit", "validation-schema"]))
                      : (_openBlock(), _createBlock(_component_Form, {
                          key: 1,
                          ref: "loginForm",
                          onSubmit: _ctx.onSubmitLogin,
                          "validation-schema": _ctx.loginSchema
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("div", _hoisted_66, [
                                  _cache[47] || (_cache[47] = _createElementVNode("i", { class: "bi bi-envelope me-5" }, null, -1)),
                                  _createVNode(_component_Field, {
                                    name: "email",
                                    type: "text",
                                    class: "form-control shadow-none fs-md-15 text-black",
                                    placeholder: "Entrer votre email"
                                  })
                                ]),
                                _createVNode(_component_ErrorMessage, {
                                  name: "email",
                                  class: "text-danger"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                  _cache[48] || (_cache[48] = _createElementVNode("i", { class: "bi bi-lock me-5" }, null, -1)),
                                  _createVNode(_component_Field, {
                                    name: "password",
                                    type: _ctx.showPassword ? 'text' : 'password',
                                    class: "form-control shadow-none fs-md-15 text-black",
                                    placeholder: "Entrer votre mot de passe"
                                  }, null, 8, ["type"]),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["bi password-eye", _ctx.showPassword ? 'bi-eye' : 'bi-eye-slash']),
                                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
                                    style: {"top":"50%","right":"10px","transform":"translateY(-50%)","cursor":"pointer"}
                                  }, null, 2)
                                ]),
                                _createVNode(_component_ErrorMessage, {
                                  name: "password",
                                  class: "text-danger"
                                })
                              ]),
                              _createElementVNode("button", {
                                class: "btn btn-primary btn-custom w-100",
                                disabled: _ctx.isLoginDisabled
                              }, [
                                (_ctx.isLoginDisabled)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_70, " Patientez " + _toDisplayString(_ctx.otpCode) + " secondes ", 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_71, " Connectez-vous "))
                              ], 8, _hoisted_69)
                            ])
                          ]),
                          _: 1
                        }, 8, ["onSubmit", "validation-schema"]))
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("h1", _hoisted_73, _toDisplayString(_ctx.isLoginActive ? 'Bienvenue à nouveau' : 'Soyez le Bienvenue'), 1),
          _createElementVNode("p", _hoisted_74, _toDisplayString(_ctx.isLoginActive ? "Pas encore de compte ?" : "Avez-vous déjà un compte ?"), 1),
          _createElementVNode("button", {
            class: "btn btn-light px-4",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleSlide && _ctx.toggleSlide(...args)))
          }, _toDisplayString(_ctx.isLoginActive ? 'Inscrivez-vous' : 'Connectez-vous'), 1)
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showOtpModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _cache[49] || (_cache[49] = _createElementVNode("h5", { class: "text-center" }, "Vérification en deux étapes", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showOtpModal = false))
                })
              ]),
              _createElementVNode("div", _hoisted_78, [
                _cache[52] || (_cache[52] = _createElementVNode("p", { class: "text-muted small mb-3" }, "Entrez le code à 6 chiffres reçu par email", -1)),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (_ctx.globalSuccess)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                          _cache[50] || (_cache[50] = _createElementVNode("i", { class: "bi bi-check-circle-fill me-2" }, null, -1)),
                          _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.globalSuccess), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (_ctx.globalError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                          _cache[51] || (_cache[51] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2" }, null, -1)),
                          _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.globalError), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_83, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
                    return _withDirectives(_createElementVNode("input", {
                      key: i,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.otp[i - 1]) = $event),
                      onInput: ($event: any) => (_ctx.jumpToNext(i)),
                      onKeydown: _withKeys(($event: any) => (_ctx.jumpBack($event, i)), ["backspace"]),
                      type: "text",
                      inputmode: "numeric",
                      maxlength: "1",
                      class: "otp-input",
                      ref_for: true,
                      ref: (el) => _ctx.setOtpRef(el as Element | null, i - 1),
                      autocomplete: "off",
                      onKeyup: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.verifyOtpLogin && _ctx.verifyOtpLogin(...args)), ["enter"])),
                      onPaste: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.handlePaste($event)), ["prevent"]))
                    }, null, 40, _hoisted_84), [
                      [_vModelText, _ctx.otp[i - 1]]
                    ])
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showOtpModal = false))
                }, " Annuler "),
                _createElementVNode("button", {
                  class: "btn btn-outline-success",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.sendOtp && _ctx.sendOtp(...args))),
                  disabled: _ctx.otpCode > 0
                }, [
                  (_ctx.otpCode === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_87, "Demander un nouveau code"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_88, "Réessayez dans " + _toDisplayString(_ctx.otpCode) + "secondes", 1))
                ], 8, _hoisted_86),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.verifyOtpLogin && _ctx.verifyOtpLogin(...args))),
                  disabled: _ctx.otp.length !== 6
                }, " Valider ", 8, _hoisted_89)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showRegisterOtpModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _cache[53] || (_cache[53] = _createElementVNode("h5", { class: "text-center" }, "Activez-votre compte pour pouvoir vous connecter!!!!", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showRegisterOtpModal = false))
                })
              ]),
              _createElementVNode("div", _hoisted_93, [
                _cache[56] || (_cache[56] = _createElementVNode("p", { class: "text-muted small mb-3" }, "Entrez le code à 6 chiffres reçu par email", -1)),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (_ctx.globalSuccess)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                          _cache[54] || (_cache[54] = _createElementVNode("i", { class: "bi bi-check-circle-fill me-2" }, null, -1)),
                          _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.globalSuccess), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (_ctx.globalError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                          _cache[55] || (_cache[55] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2" }, null, -1)),
                          _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.globalError), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_98, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
                    return _withDirectives(_createElementVNode("input", {
                      key: i,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.registerOtp[i - 1]) = $event),
                      onInput: ($event: any) => (_ctx.jumpNext(i)),
                      onKeydown: _withKeys(($event: any) => (_ctx.jumpToBack($event, i)), ["backspace"]),
                      type: "text",
                      inputmode: "numeric",
                      maxlength: "1",
                      class: "otp-input",
                      ref_for: true,
                      ref: (el) => _ctx.setOtpRef(el as Element | null, i - 1),
                      autocomplete: "off",
                      onKeyup: _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => (_ctx.verifyOtpRegister && _ctx.verifyOtpRegister(...args)), ["enter"])),
                      onPaste: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.Pastehandle($event)), ["prevent"]))
                    }, null, 40, _hoisted_99), [
                      [_vModelText, _ctx.registerOtp[i - 1]]
                    ])
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showRegisterOtpModal = false))
                }, " Annuler "),
                _createElementVNode("button", {
                  class: "btn btn-outline-success",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.sendOtp && _ctx.sendOtp(...args))),
                  disabled: _ctx.otpCode > 0
                }, [
                  (_ctx.otpCode === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_102, "Demander un nouveau code"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_103, "Réessayez dans " + _toDisplayString(_ctx.otpCode), 1))
                ], 8, _hoisted_101),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.verifyOtpRegister && _ctx.verifyOtpRegister(...args))),
                  disabled: _ctx.registerOtp.length !== 6
                }, " Valider ", 8, _hoisted_104)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}